export default class Stage {
    constructor () {
        this.id = null
        this.stage_id = null
        this.opportunity_id = null
        this.budget_id = null
        this.sla_id = null
        this.commenced = null
        this.completed = null
    }
}